// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "src": {
            "type": "STRING"
        },
        "provider": {
            "type": "STRING"
        },
        "catalogspaceid": {
            "type": "STRING"
        },
        "locale": {
            "type": "STRING"
        },
        "sub-panel-context": {
            "type": "object"
        }
    },
    "data": {},
    "_viewModelId": "DesWebgl",
    "_uniqueViewModelId": "DesWebgl",
    "ctx": {}
};

    /*
    <div class="webGl-styling">
    <aw-panel>
        <iframe src="{{props.subPanelContext.viewerSRC || props.src}}"></iframe>
    </aw-panel>
</div>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div className="webGl-styling">
        <AwPanel  revealAction={actions.reveal}>
            <iframe src={AwParseService.instance( "props.subPanelContext.viewerSRC || props.src" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            </iframe>
        </AwPanel>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;